import { z } from 'zod'

export const ADMINAGENTSGETACCESS_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsGetAccessResponseSchema = z.unknown()
export type AdminAgentsGetAccessResponse = z.infer<typeof adminAgentsGetAccessResponseSchema>
